import { useStore } from "@/context/StoreContext";
import { ProductCard } from "@/components/ProductCard";
import { Marquee } from "@/components/Marquee";
import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";

export default function Shop() {
  const { products, bundle, openCheckout } = useStore();
  const navigate = useNavigate();

  return (
    <div>
      <section className="mx-auto max-w-7xl px-5 pt-16 lg:px-8 lg:pt-24" data-testid="shop-page">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground">Shop</p>
          <h1 className="mt-4 max-w-3xl font-display text-5xl font-extrabold tracking-tighter sm:text-6xl">Premium guides for every part of your life.</h1>
          <p className="mt-5 max-w-md text-muted-foreground">Choose a single guide, or get all three in the bundle and save.</p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
          {products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
        </div>
      </section>

      <div><Marquee /></div>

      {bundle && (
        <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8">
          <div className="relative grid grid-cols-1 items-center gap-10 border border-black/10 bg-[#0a0a0a] p-8 text-white lg:grid-cols-2 lg:p-16">
            <div className="absolute right-0 top-0 bg-white px-4 py-1.5 text-[10px] uppercase tracking-[0.2em] text-foreground">Best Value</div>
            <div>
              <p className="text-[11px] uppercase tracking-[0.25em] text-white/50">Bundle</p>
              <h2 className="mt-4 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{bundle.title}</h2>
              <ul className="mt-8 space-y-3">
                {bundle.whats_included?.map((g) => <li key={g} className="flex items-center gap-3 text-sm text-white/80"><Check className="h-4 w-4" /> {g}</li>)}
              </ul>
              <div className="mt-8 flex items-end gap-3">
                <span className="font-display text-4xl">${bundle.price?.toFixed(2)}</span>
                <span className="mb-1 text-lg text-white/40 line-through">${bundle.compare_at_price?.toFixed(2)}</span>
              </div>
              <Button data-testid="shop-bundle-cta" onClick={() => navigate("/bundle")} className="mt-8 rounded-none h-12 bg-white px-8 text-foreground hover:bg-white/90">View Bundle</Button>
            </div>
            <div className="overflow-hidden border border-white/10">
              <img src={bundle.mockup_image} alt={bundle.title} className="aspect-[4/3] w-full object-cover grayscale" />
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
